export default __webpack_public_path__ + "static/media/img-gnb-men-off.009f5e7d.svg";